// extracted by mini-css-extract-plugin
module.exports = {"banner-picture":"banner-picture-adc0acb0ecbd52f795691a778c0ea78c"};